/**
 * Reservation Form Module
 *
 * Handles AJAX form submission for reservations.
 */
export class ReservationForm {
    constructor(formSelector) {
        this.form = document.querySelector(formSelector);
        if (!this.form) return;
        this.init();
    }

    init() {
        this.submitBtn = this.form.querySelector('[type="submit"]');
        this.messageEl = this.form.querySelector('.form-message') || this.createMessageEl();
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    createMessageEl() {
        const el = document.createElement('div');
        el.className = 'form-message';
        el.style.display = 'none';
        this.form.prepend(el);
        return el;
    }

    async handleSubmit(e) {
        e.preventDefault();

        if (!this.validate()) return;

        this.setLoading(true);

        try {
            const formData = new FormData(this.form);
            formData.append('action', 'flavor_submit_reservation');
            formData.append('nonce', window.flavorData?.nonce || '');

            const response = await fetch(window.flavorData?.ajaxUrl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (result.success) {
                this.showMessage('success', result.data?.message || 'Reservation submitted!');
                this.form.reset();
            } else {
                this.showMessage('error', result.data?.message || 'An error occurred.');
            }
        } catch (error) {
            this.showMessage('error', window.flavorData?.i18n?.error || 'An error occurred.');
        } finally {
            this.setLoading(false);
        }
    }

    validate() {
        const required = this.form.querySelectorAll('[required]');
        let valid = true;

        required.forEach((field) => {
            field.classList.remove('form-control--error');
            if (!field.value.trim()) {
                field.classList.add('form-control--error');
                valid = false;
            }
        });

        return valid;
    }

    showMessage(type, text) {
        this.messageEl.className = `form-message form-message--${type}`;
        this.messageEl.textContent = text;
        this.messageEl.style.display = 'block';

        // Scroll to message
        this.messageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    setLoading(loading) {
        this.submitBtn.disabled = loading;
        this.submitBtn.textContent = loading
            ? (window.flavorData?.i18n?.sending || 'Sending...')
            : this.submitBtn.dataset.originalText || 'Submit';

        if (!loading) return;
        this.submitBtn.dataset.originalText = this.submitBtn.dataset.originalText || this.submitBtn.textContent;
    }
}
